import { HttpErrorResponse } from '@angular/common/http';
import { PipelineStageConfig } from '../interfaces/biozoom-api/pipeline';
import { environment } from '../../environments/environment';

export const getUploadHttpStatus = (error: any): number | null =>
  error instanceof HttpErrorResponse ? error.status : null;

/** Write one final diagnostic record for a logical upload network stage. */
export const logUploadNetworkSummary = (
  pipelineConfig: PipelineStageConfig,
  nextStage: string | undefined,
  network: Record<string, any>,
) => {
  if (environment.appDesignSettings?.logSystem !== true || environment.appDesignSettings?.logNetwork !== true) {
    return;
  }

  void pipelineConfig.pushToLog({
    msg: 'Upload network summary',
    type: 'upload-network-summary',
    currentStage: pipelineConfig.stage ?? '',
    nextStage: nextStage ?? '',
    timestamp: Math.floor(Date.now() / 1000),
    network,
  });
};
